import { render, staticRenderFns } from "./sh_WizardVerification.vue?vue&type=template&id=9b39c2f4&"
import script from "./sh_WizardVerification.vue?vue&type=script&lang=js&"
export * from "./sh_WizardVerification.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/bank_verification.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./sh_WizardVerification.vue?vue&type=style&index=1&id=9b39c2f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports